module.exports = __webpack_public_path__ + "static/media/henrik-pettersson-starka-resultat.7baa727f.png";